import React from 'react'
import OperacionesCereales from '../../Dashboard/components/cereales/OperacionesCereales'

export const COL_CEREALES = [
  {
    name: 'nombreCorto',
    label: 'Nombre corto',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'nombre',
    label: 'Nombre',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'limiteDeHumedad',
    label: 'Limite de humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pesoEspecifico',
    label: 'Peso especifico',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'habilitado',
    label: 'Habilitado',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (habilitado) => {
        return habilitado ? 'Si' : 'No'
      }
    }
  },
  {
    name: 'entry',
    label: ' ',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (entry) => {
        return <OperacionesCereales data={entry} />
      }
    }
  }
]
